import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'

interface TruncatedProps extends TextProps {
  clip?: boolean
}

export const TruncatedText: React.FC<TruncatedProps> = ({ clip, ...rest }) => (
  <Text
    overflow="hidden"
    textOverflow={clip ? 'clip' : 'ellipsis'}
    whiteSpace="nowrap"
    width="100%"
    {...rest}
  />
)
